import { Route } from '@angular/router';

import { HomeComponent } from './home.component';
import { LandingComponent } from '../landing/landing.component';

export const HOME_ROUTE: Route = {
  path: 'lista-servizi',
  component: HomeComponent,
  data: {
    pageTitle: 'home.title',
  },
};
